import { render } from "./MoreLessButton.vue?vue&type=template&id=4b567710&scoped=true"
import script from "./MoreLessButton.vue?vue&type=script&lang=js"
export * from "./MoreLessButton.vue?vue&type=script&lang=js"

import "./MoreLessButton.vue?vue&type=style&index=0&id=4b567710&scoped=true&lang=css"

import exportComponent from "/var/www/abg/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b567710"]])

export default __exports__